module.exports = __webpack_public_path__ + "img/co1.02c4d370.png";